<template>
  <div class="main" :style="{'minHeight': mainHeight}">

    <div class="blocks">
      <div style="text-align: left;line-height: 32px;font-size: 17px;color:#ffffff;padding: 15px 0;">
        Plese send us your message using this form.<br />
        Be sure to give the correct e-Mail address, so we can call you back.
      </div>

      <el-form :model="formData" ref="form" :rules="rules" label-width="135px" class="mtb10" label-position="left" :hide-required-asterisk="true">

        <el-form-item label="Your name" prop="name">
          <el-input class="customInp" v-model="formData.name"></el-input>
        </el-form-item>

        <el-form-item label="Your E-mail" prop="email">
          <el-input class="customInp" v-model="formData.email"></el-input>
        </el-form-item>

        <el-form-item label="Subject*" prop="subject">
          <el-input class="customInp" v-model="formData.subject"></el-input>
        </el-form-item>

        <br/>

        <el-form-item label="Message*" prop="message">
          <el-input class="customInp" v-model="formData.message" type="textarea" size="mini" :rows="10"></el-input>
        </el-form-item>
      </el-form>

      <div class="f-r-c customInp ">
        <div class="blockBtn mtb10" @click="submit">Send your message to us</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'feedback',
  data () {
    return {
      mainHeight: 0,
      formData: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: 'Please enter name', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Please enter email', trigger: 'blur' },
          { type: 'email', message: 'Please enter the correct email', trigger: 'blur' }
        ],
        subject: [
          { required: true, message: 'Please enter subject', trigger: 'blur' }
        ],
        message: [
          { required: true, message: 'Please enter message', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

      var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

      this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')

      window.addEventListener('resize', function () {
        var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

        var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

        this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')
      }.bind(this))
    })
  },
  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl('/ga/feedback'),
            method: 'post',
            data: this.$http.adornData(this.formData)
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$alert('Sending succeeded! Please wait for our contact.', 'Tips', {
                confirmButtonText: 'confirm',
                customClass: 'feedbackTip',
                callback: action => {
                  this.$router.replace('home')
                }
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../../static/img/background.png") no-repeat;
    background-size: 100% 100%;
  }
  .blocks {
    padding: 25px 0;
    width: 50%;
    min-width: 960px
  }
  * /deep/ .customInp {width: 80%;margin-right: 20%}
  * /deep/ .customInp input {
    background: #929D34;color:white;
    border: 1px solid white;font-size: 15px;
    height: 32px;line-height:32px; border-radius: 15px;
  }
  * /deep/ .customInp textarea {
    background: #D2DA84;box-shadow:8px 10px 20px 0 #728108;color:white;font-size: 15px;border-radius: 15px;
  }
  * /deep/ .el-textarea__inner:focus {
    border-color: #929D34;
  }
  * /deep/ .el-form-item__label {
    font-size: 18px;
    font-weight: bold;
    color: #492500;
  }
</style>
<style>
  .feedbackTip * .el-button {
    background: #929D34;
    border-color: #929D34;
  }
</style>



// WEBPACK FOOTER //
// src/components/feedback.vue